import { CSSProperties, Dispatch, ReactNode, SetStateAction, useEffect, useState } from 'react'
import styles from './modal.module.css'

export default function Modal({
  title = null,
  isShown = true,
  setIsShown,
  children,
  className,
  style = {},
  onClose,
  skip = false,
}: {
  title?: ReactNode
  isShown?: boolean
  setIsShown?: Dispatch<SetStateAction<boolean>>
  children: React.ReactNode
  className?: string
  style?: CSSProperties
  onClose?: () => void
  skip?: boolean
}) {
  const [isInitShown, setIsInitShown] = useState<boolean>(() => false)
  useEffect(() => {
    isShown && setIsInitShown(() => true)
  }, [isShown])

  const handleClose = () => {
    setIsShown && setIsShown(() => false)
    onClose && onClose()
  }

  return skip ? (
    <>{children}</>
  ) : (
    <div
      role='button'
      tabIndex={-1}
      onClick={handleClose}
      className={`
          ${!isInitShown ? 'hidden' : ''}
          ${isShown ? styles.item : styles.itemFadeout}
          modal h-screen w-full fixed left-0 top-0 flex justify-center items-center bg-black bg-opacity-40 z-[200]
        `}
    >
      <div
        tabIndex={-1}
        className={`
              bg-white rounded-2xl shadow-lg w-10/12 lg:w-9/12 xl:w-2/3 2xl:w-1/2 max-h-full overflow-y-auto relative
              ${className ? className : ''}
            `}
        onClick={(e) => {
          e.stopPropagation()
        }}
        style={style}
      >
        {!!title && (
          <div className='border-b px-8 py-5 flex pr-[2em] justify-between items-center'>
            {typeof title === 'string' ? (
              <h3 className='font-semibold text-lg'>{title || ''}</h3>
            ) : (
              title
            )}
          </div>
        )}

        <div
          className={`
              absolute 
              ${!!title ? 'right-[1.4em] top-[1.4em]' : 'right-[1em] top-[1em]'}
            `}
        >
          <button className='close-modal' onClick={handleClose}>
            <svg
              className='fill-slate-400'
              width='1.8rem'
              height='1.8rem'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path d='M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z' />
            </svg>
          </button>
        </div>

        <div className='px-10 pt-6 pb-8'>{children}</div>
      </div>
    </div>
  )
}
